import { questionAction } from './question.slice';
import { getQuestionsApi } from 'utils/apis';
import { STATUS_CODE } from 'common/constants';
import { setSelectedQuestion, setUpdatedQuestion } from 'utils/functions';

export const fetchQuestions = (payload) => async (dispatch) => {
  try {
    dispatch(questionAction.getQuestionList());
    const response = await getQuestionsApi(payload);
    if (response.status === STATUS_CODE.Ok) {
      const updatedQuestion = setUpdatedQuestion(response.data.data);
      const selectedIds = setSelectedQuestion(updatedQuestion);
      await dispatch(questionAction.setSelectedQuestions(selectedIds));
      await dispatch(questionAction.setQuestions(updatedQuestion));
    }
  } catch (err) {
    dispatch(questionAction.stopLoading());
  }
};

export const handleQuestionsSelection = (selectedval) => async (dispatch) => {
  dispatch(questionAction.setSelectedQuestions(selectedval));
};
export const handleReportName = (reportname) => async (dispatch) => {
  dispatch(questionAction.setReportName(reportname));
};
